<template>
  <div class="login" style="margin: 30px;">
    <van-button
      color="#437fee"
      @click="clickMeds()"
      :loading="loading"
      loading-text="授权中..."
    >
      华夏点击授权1
    </van-button>
  </div>
</template>

<script>
import { getAuthorize } from '@/api/testhx.js'
export default {
  name: 'Login',
  data() {
    return {
      loading: false
    }
  },
  created() {
    console.log(this.$route.query)
  },
  methods: {
    // getQueryString(name) {
    //   const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    //   const r = window.location.search.substr(1).match(reg)
    //   if (r != null) return decodeURI(r[2])
    //   return null
    // },
    async clickMeds() {
      try {
        this.loading = true
        const data = await getAuthorize(`https://hxbankt.yidianlife.cn/#/test/hxlogin?activityNumber=${this.$route.query.activitynumber}`)
        console.log('auth', data)
        this.loading = false
        window.location.href = `https://app.creditcard.hxb.com.cn/open/oauth/authorize?appid=${
          data.appid
        }&scope=${data.scope}&redirect_uri=${encodeURIComponent(
          data.redirect_uri
        )}&response_type=${data.response_type}&timestamp=${
          data.timestamp
        }&random=${data.random}&sign=${data.sign}`
      } catch (error) {
        this.loading = false
        console.log(error)
      }
    }
  }
}
</script>
<style lang="less" scoped></style>
